import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { createContext } from 'react';
export var AnnotationsDraftContext = /*#__PURE__*/createContext(null);
export var ProvidersContext = /*#__PURE__*/createContext(null);
export var InlineCommentsStateContext = /*#__PURE__*/createContext({});

// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
export var AnnotationsDraftContextWrapper = /*#__PURE__*/function (_React$Component) {
  function AnnotationsDraftContextWrapper() {
    var _this;
    _classCallCheck(this, AnnotationsDraftContextWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AnnotationsDraftContextWrapper, [].concat(args));
    _defineProperty(_this, "state", {
      position: null
    });
    _defineProperty(_this, "applyAnnotationDraftAt", function (nextPosition) {
      var setDraftRange = _this.props.setDraftRange;

      // Set the draft range to preserve it downstream
      setDraftRange();

      // We need to support a new draft being made while one exists and overwrite it
      // Set the document position for the newly created draft
      _this.setState({
        position: nextPosition
      });
    });
    _defineProperty(_this, "clearAnnotationDraft", function () {
      var clearDraftRange = _this.props.clearDraftRange;

      // Clear the draft range
      clearDraftRange();

      // Clear the draft position in the document
      _this.setState({
        position: null
      });
    });
    return _this;
  }
  _inherits(AnnotationsDraftContextWrapper, _React$Component);
  return _createClass(AnnotationsDraftContextWrapper, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var position = this.state.position;
      var applyAnnotationDraftAt = this.applyAnnotationDraftAt;
      var clearAnnotationDraft = this.clearAnnotationDraft;
      return /*#__PURE__*/React.createElement(AnnotationsDraftContext.Provider, {
        value: position
      }, children({
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        clearAnnotationDraft: clearAnnotationDraft
      }));
    }
  }]);
}(React.Component);